import { render, staticRenderFns } from "./teacher-contact-data.vue?vue&type=template&id=74c62374&"
import script from "./teacher-contact-data.vue?vue&type=script&lang=js&"
export * from "./teacher-contact-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports